import { z } from "zod";
import { baseURL } from "../utils/base-url";
import { axiosInstance } from "..";
import { getAuthHeaders } from "../utils/headers";
import { NetworxResponse } from "../utils/types";

export async function getLeads(data: ParamsLeads) {
  const response = await axiosInstance.post<
    NetworxResponse<unknown, ResponseLeads>
  >(`/leads`, data, {
    validateStatus: function (status) {
      return status < 500;
    },
    baseURL: baseURL.homeowner_v2,
    headers: getAuthHeaders(),
    meta: {
      disableToasts: true,
    },
  });
  return response.data;
}

export const ParamsLeadsSchema = z.object({
  f_name: z.string(),
  n_phone: z.string(),
  zip: z.string(),
  email: z.string().optional(),
  address: z.string().optional(),
  question: z.record(z.string(), z.string()).optional(),
  task_id: z.string().optional(),
  service: z.number(),
  source_id: z.string(),
  preference_to: z.string().optional(),
  tcpa_compliance_text: z.string().optional(),
  add_info: z.string().optional(),
  viewed_contractors: z.array(
    z.object({
      id: z.number(),
      accepted: z.boolean(),
      // INFO: this is 1-based position, i.e. should start by 1.
      position: z.number(),
    }),
  ).optional(),
  xxTrustedFormCertUrl: z.string(),
  xxTrustedFormToken: z.string().optional(),
  xxTrustedFormPingUrl: z.string().optional(),
});
export type ParamsLeads = z.infer<typeof ParamsLeadsSchema>;

export type ResponseLeads =
  | {
      /** should be here when is_success is true */
      redirect_url: string;
    }
  | {
      /** should be here when is_success is false */
      validation_errors: {
        phone?: string;
        name?: string;
        zip_code?: string;
        task_id?: string;
        submitted_email?: string;
      };
    };
